(ns app.components.cards.styles
  (:require-macros)
  (:require
   [spade.core   :refer [defglobal defclass]]
   [garden.stylesheet :refer [at-media]]))

(defclass product-card-style
  []
  {:display "flex"
   :justify-content "center"
   :align-items "center"
   :background "white"
   :border-radius "6px"
   :margin-right "24px"
   :margin-bottom "24px"
   :cursor "pointer"
   :outline "1px solid #E0DFE4"
   :outline-offset "-1px"}
  [:&:hover
   {:box-shadow "0 8px 26px rgb(103 110 144 / 20%)"}])

(defclass create-product-card-style
  []
  {:cursor "pointer"
   :display "flex"
   :justify-content "center"
   :align-items "center"
   :background "white"
   :width "239.5px"
   :height "160px"
   :border-radius "8px"})

(defclass activity-card-style
  []
  {:margin "0px 24px"
   :gap "8px"
   :width "19%"}
  [(at-media {:max-width "1340px"}
             {:margin "0px 16px"
              :gap "0px"
              :width "19%"})]) 

(defclass arrow-down []
  {:width "18px"
   :height "18px"}
  [(at-media {:max-width "1340px"}
             {:width "11px"
              :height "11px"})])

(defclass arrow-up []
  {:width "18px"
   :height "18px"}
  [(at-media {:max-width "1340px"}
             {:width "11px"
              :height "11px"})])


(defclass activity-card-movement-up-style
  []
  {:font-weight "700"
   :font-size "14px"
   :color :theme/*green*} 
  [(at-media {:max-width "1340px"}
             {:font-size "9px"})] 
  )

(defclass activity-card-movement-down-style
  []
  {:font-weight "700"
   :font-size "14px"
   :color :theme/*red*}
    [(at-media {:max-width "1340px"}
               {:font-size "9px"})])

(defclass activity-card-side-note-style
  []
  {:padding "0px 2px "
   :font-size "10px"
   :align-items "baseline"}
  [(at-media {:max-width "1450px"}
             {:padding "0px 2px "
              :font-size "9px"
              :align-items "baseline"})]
  [(at-media {:max-width "1250px"}
             {:padding "0px 2px "
              :font-size "0px"
              :align-items "baseline"})])

(defclass image-container
  []
  {:display "flex" :justify-content "center" :align-items "center"
   :width "297px" :height "160px"})

(defclass product-image
  []
  {:border-top-left-radius "6px"
   :border-top-right-radius "6px"})

(defclass product-info-container
  []
  {:padding "12px 0px"
   :border-top "1px solid #E0DFE4"
   :height "33.5px"})

(defclass new-card-style
  []
  {:display "flex"
   :justify-content "center"
   :align-items "center"
   :background "white"
   :width "239.5px"
   :height "160px"
   :border-radius "8px"})